import { render, staticRenderFns } from "./stores_statistiques.vue?vue&type=template&id=fdfb64c2&scoped=true"
import script from "./stores_statistiques.vue?vue&type=script&lang=js"
export * from "./stores_statistiques.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdfb64c2",
  null
  
)

export default component.exports